import React from "react";
import PropTypes from "prop-types";

import "./subheadline.m.css";

export const Subheadline = ({ story, subheadlineColor = "#616160" }) => {
  const subheadline = story.subheadline || "";
  return (
    subheadline && (
      <h1
        styleName="subheadline"
        className="subheadline"
        style={{ color: subheadlineColor }}
      >
        <bdi dangerouslySetInnerHTML={{ __html: story.subheadline }} />
      </h1>
    )
  );
};

Subheadline.propTypes = {
  story: PropTypes.object,
  subheadlineColor: PropTypes.string
};
